// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media all {
  /* Tooltips */
  :host ::ng-deep ngb-tooltip-window {
    z-index: 999;
  }
  .table-wrap {
    overflow: auto;
  }

  /* Calendar Filter Styles */
  :host ::ng-deep p-calendar span.p-calendar {
    margin-left: 0;
    margin-right: 0;
    padding-left: 0;
    padding-right: 0;
  }

  :host ::ng-deep p-calendar span input {
    margin: unset;
  }

  :host ::ng-deep p-calendar .p-datepicker {
    border-radius: 4px;
    color: rgb(73, 80, 87);
    padding: 0.5rem;
    position: absolute;
    top: -15rem;
    width: 22rem;
  }

  :host ::ng-deep p-calendar .p-calendar .p-datepicker {
    box-shadow: 3px 3px 5px rgba(28, 42, 57, 0.5);
    left: -9vw !important;
    min-height: 22rem;
    min-width: 21rem;
  }

  :host ::ng-deep p-calendar table tr:nth-child(even) {
    background-color: unset !important;
  }

  :host ::ng-deep p-calendar .p-datepicker-calendar tbody tr td,
  :host ::ng-deep p-calendar .p-datepicker-calendar thead tr th {
    border: none;
  }


  :host ::ng-deep p-calendar .p-datepicker-calendar tbody tr td span {
    border-radius: 50%;
    font-weight: bold;
    width: 1.5rem;
    text-align: center;
  }

  :host ::ng-deep p-calendar .p-datepicker-calendar tbody tr td span:hover {
    background-color: rgb(65, 81, 100);
    color: rgb(255, 255, 255);
  }

  :host ::ng-deep p-calendar .p-datepicker-calendar thead tr th,
  :host ::ng-deep p-calendar .p-datepicker-calendar .p-datepicker-other-month {
    color: rgb(144, 161, 182);
    font-weight: normal;
    text-align: center;
  }

  :host ::ng-deep p-calendar .p-datepicker-header {
    background-color: rgb(65, 81, 100);
    color: rgb(255, 255, 255);
    font-size: 1rem;
    height: 3rem;
  }

  :host ::ng-deep p-calendar .p-datepicker-next,
  :host ::ng-deep p-calendar .p-datepicker-prev {
    background: transparent;
    border: 0;
  }

  :host ::ng-deep p-calendar .p-datepicker-next-icon,
  :host ::ng-deep p-calendar .p-datepicker-prev-icon {
    color: rgb(255, 255, 255);
    font-size: 1rem !important;
  }

  :host ::ng-deep p-calendar .p-datepicker-month {
    margin-right: 0.5rem;
  }

  :host ::ng-deep p-calendar .p-calendar .p-datepicker:not(.p-datepicker-inline) {
    background: rgb(255, 255, 255);
    border: 0 none;
  }

  /* Table Styles */
  :host ::ng-deep p-table p-table {
    margin-bottom: 5rem;
  }

  :host ::ng-deep p-table table {
    font-size: .87rem;
  }

  :host ::ng-deep p-table thead.p-datatable-thead {
    background-color: rgb(65, 81, 100);
    color: rgb(255, 255, 255);
    font-weight: bold;
    line-height: 3rem;
  }

  :host ::ng-deep p-table tbody tr {
    line-height: 1.5rem;
  }

  :host ::ng-deep p-table tbody tr:nth-child(even) {
    background-color: rgb(245, 246, 250);
  }

  :host ::ng-deep p-table tbody tr td,
  :host ::ng-deep p-table thead th,
  :host ::ng-deep .p-sortable-column {
    padding: 0 1rem;
  }

  :host ::ng-deep p-table tbody tr td {
    width: 10%;
    padding: 10px;
  }
  :host ::ng-deep p-table tbody tr.nested-table-body-row td {
    padding: 1rem;
  }

  :host ::ng-deep th p-sortIcon i,
  :host ::ng-deep p-table thead th i {
    font-size: 0.9rem;
  }

  :host ::ng-deep p-calendar span input,
  :host ::ng-deep .p-column-filter,
  :host ::ng-deep .p-column-filter-text {
    border-radius: 4px;
    height: 100%;
    line-height: 1.5rem;
    /*margin: 0.5rem 0;*/
    padding: 0.5rem;
    width: 100%;
  }

  :host ::ng-deep .p-column-filter-text {
    background: rgb(255, 255, 255) url(/assets/images/input-search-icon.svg) no-repeat 8px;
  }

  :host ::ng-deep .p-datatable-resizable > .p-datatable-wrapper {
    overflow-x: visible;
    min-height: 450px;
  }

  :host ::ng-deep .p-highlight {
    border: none;
    font-weight: bold;
  }

  :host ::ng-deep .nested-table {
    border: unset;
  }

  :host ::ng-deep .p-paginator-page:not(.p-highlight),
  :host ::ng-deep p-table thead th,
  :host ::ng-deep .p-datatable-gridlines tbody tr td {
    border: 1px solid rgb(209, 211, 219);
  }

  :host ::ng-deep .p-paginator-next,
  :host ::ng-deep .p-paginator-prev {
    border: 0;
  }

  :host ::ng-deep .p-paginator {
    float: left;
    margin: 1.5rem 1.5rem 1.5rem 0;
  }

  :host ::ng-deep span .p-paginator-page:not(.p-highlight) {
    background-color: unset;
  }

  :host ::ng-deep .p-paginator-element {
    background-color: rgb(245, 246, 250);
    border-radius: .2rem;
    height: 2rem;
    margin-right: .5rem;
    width: 2rem;
  }

  :host ::ng-deep .p-paginator-icon {
    color: rgb(000, 000, 000);
  }

  :host ::ng-deep .p-paginator-first,
  :host ::ng-deep .p-paginator-last {
    display: none;
  }

  :host ::ng-deep .p-paginator-current {
    order: 2;
  }

  :host ::ng-deep .ui-dropdown-label {
    font-size: 0.875rem;
    padding: 0.5rem 0.5rem 0.5rem 1.4rem
  }

  td span {
    white-space: normal;
  }

  .actionColumn {
    width: 80px;
  }

  :host ::ng-deep .calendar-clear-button {
    background: transparent;
    border: 0;
    font-weight: bold;
    margin: 0.5rem auto 0;
    text-decoration: underline;
  }

  .calendar-element-today {
    border: 1px solid rgb(65, 81, 100);
  }

  .checkbox-container {
    margin-bottom: 0.5rem;
    margin-top: 0.5rem;
  }

  .checkbox-description {
    margin-left: 2.5rem;
  }

  .checkmark {
    border-radius: 6px;
    border-width: 2px;
    /*height: 1.5rem;*/
    /*width: 1.5rem;*/
    height: 28px;
    width: 28px;
  }

  .chevron-link {
    display: inline-flex;
  }

  .display-contents {
    display: contents;
  }

  .display-none,
  :host ::ng-deep .display-none {
    display: none;
  }

  .down-arrow:not(.show) {
    transform: rotate(90deg);
  }

  .down-arrow, .down-arrow.show {
    background: url(/assets/images/up-arrow-offgray.svg) no-repeat;
    height: 7px;
    float: left;
    margin-right: 5px;
    margin-left: 0;
    width: 11px;
  }

  .down-arrow.show {
    transform: rotate(180deg);
  }

  .missing-data-message {
    font-weight: bold;
    margin: 2rem auto;
    text-align: center;
  }

  .nested-table td:first-child {
    padding: 0;
  }

  tr.table-emptymesage td {
    height: 30rem;
    margin-top: 8rem;
    text-align: center;
    text-decoration: underline !important;
    vertical-align: middle;
  }

  tr.table-emptymesage a {
    color: rgb(79, 169, 247);
    font-size: 1rem;
  }

  tr.table-emptymesage td a:hover {
    cursor: grabbing;
  }

  tr.nested-table-body-row td {
    border: 0 !important;
  }

  tr.nested-table-header th {
    background: transparent;
    border: 0 !important;
    color: rgb(0, 0, 0);
    padding-top: 1rem;
  }

  tr.nested-table-header th:first-child,
  tr.nested-table-body-row td:first-child {
    padding-left: 1.7rem;
  }

  tr.nested-table td div p-table ::ng-deep div div table thead {
    background-color: unset;
  }

  .table-responsive {
    margin-top: 4rem;
  }

  .u-ta-c {
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/components/tables/table-generic/table-generic.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;;EAEA,2BAA2B;EAC3B;IACE,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,6CAA6C;IAC7C,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kCAAkC;EACpC;;EAEA;;IAEE,YAAY;EACd;;;EAGA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,kCAAkC;IAClC,yBAAyB;EAC3B;;EAEA;;IAEE,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,kCAAkC;IAClC,yBAAyB;IACzB,eAAe;IACf,YAAY;EACd;;EAEA;;IAEE,uBAAuB;IACvB,SAAS;EACX;;EAEA;;IAEE,yBAAyB;IACzB,0BAA0B;EAC5B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,8BAA8B;IAC9B,cAAc;EAChB;;EAEA,iBAAiB;EACjB;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kCAAkC;IAClC,yBAAyB;IACzB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oCAAoC;EACtC;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,aAAa;EACf;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;;;IAGE,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,sFAAsF;EACxF;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;;;IAGE,oCAAoC;EACtC;;EAEA;;IAEE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,oCAAoC;IACpC,oBAAoB;IACpB,YAAY;IACZ,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,mBAAmB;IACnB;EACF;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,SAAS;IACT,iBAAiB;IACjB,qBAAqB;IACrB,0BAA0B;EAC5B;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,8DAA8D;IAC9D,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,WAAW;EACb;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,qCAAqC;IACrC,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;IACxB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;;IAEE,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["@media all {\n  /* Tooltips */\n  :host ::ng-deep ngb-tooltip-window {\n    z-index: 999;\n  }\n  .table-wrap {\n    overflow: auto;\n  }\n\n  /* Calendar Filter Styles */\n  :host ::ng-deep p-calendar span.p-calendar {\n    margin-left: 0;\n    margin-right: 0;\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  :host ::ng-deep p-calendar span input {\n    margin: unset;\n  }\n\n  :host ::ng-deep p-calendar .p-datepicker {\n    border-radius: 4px;\n    color: rgb(73, 80, 87);\n    padding: 0.5rem;\n    position: absolute;\n    top: -15rem;\n    width: 22rem;\n  }\n\n  :host ::ng-deep p-calendar .p-calendar .p-datepicker {\n    box-shadow: 3px 3px 5px rgba(28, 42, 57, 0.5);\n    left: -9vw !important;\n    min-height: 22rem;\n    min-width: 21rem;\n  }\n\n  :host ::ng-deep p-calendar table tr:nth-child(even) {\n    background-color: unset !important;\n  }\n\n  :host ::ng-deep p-calendar .p-datepicker-calendar tbody tr td,\n  :host ::ng-deep p-calendar .p-datepicker-calendar thead tr th {\n    border: none;\n  }\n\n\n  :host ::ng-deep p-calendar .p-datepicker-calendar tbody tr td span {\n    border-radius: 50%;\n    font-weight: bold;\n    width: 1.5rem;\n    text-align: center;\n  }\n\n  :host ::ng-deep p-calendar .p-datepicker-calendar tbody tr td span:hover {\n    background-color: rgb(65, 81, 100);\n    color: rgb(255, 255, 255);\n  }\n\n  :host ::ng-deep p-calendar .p-datepicker-calendar thead tr th,\n  :host ::ng-deep p-calendar .p-datepicker-calendar .p-datepicker-other-month {\n    color: rgb(144, 161, 182);\n    font-weight: normal;\n    text-align: center;\n  }\n\n  :host ::ng-deep p-calendar .p-datepicker-header {\n    background-color: rgb(65, 81, 100);\n    color: rgb(255, 255, 255);\n    font-size: 1rem;\n    height: 3rem;\n  }\n\n  :host ::ng-deep p-calendar .p-datepicker-next,\n  :host ::ng-deep p-calendar .p-datepicker-prev {\n    background: transparent;\n    border: 0;\n  }\n\n  :host ::ng-deep p-calendar .p-datepicker-next-icon,\n  :host ::ng-deep p-calendar .p-datepicker-prev-icon {\n    color: rgb(255, 255, 255);\n    font-size: 1rem !important;\n  }\n\n  :host ::ng-deep p-calendar .p-datepicker-month {\n    margin-right: 0.5rem;\n  }\n\n  :host ::ng-deep p-calendar .p-calendar .p-datepicker:not(.p-datepicker-inline) {\n    background: rgb(255, 255, 255);\n    border: 0 none;\n  }\n\n  /* Table Styles */\n  :host ::ng-deep p-table p-table {\n    margin-bottom: 5rem;\n  }\n\n  :host ::ng-deep p-table table {\n    font-size: .87rem;\n  }\n\n  :host ::ng-deep p-table thead.p-datatable-thead {\n    background-color: rgb(65, 81, 100);\n    color: rgb(255, 255, 255);\n    font-weight: bold;\n    line-height: 3rem;\n  }\n\n  :host ::ng-deep p-table tbody tr {\n    line-height: 1.5rem;\n  }\n\n  :host ::ng-deep p-table tbody tr:nth-child(even) {\n    background-color: rgb(245, 246, 250);\n  }\n\n  :host ::ng-deep p-table tbody tr td,\n  :host ::ng-deep p-table thead th,\n  :host ::ng-deep .p-sortable-column {\n    padding: 0 1rem;\n  }\n\n  :host ::ng-deep p-table tbody tr td {\n    width: 10%;\n    padding: 10px;\n  }\n  :host ::ng-deep p-table tbody tr.nested-table-body-row td {\n    padding: 1rem;\n  }\n\n  :host ::ng-deep th p-sortIcon i,\n  :host ::ng-deep p-table thead th i {\n    font-size: 0.9rem;\n  }\n\n  :host ::ng-deep p-calendar span input,\n  :host ::ng-deep .p-column-filter,\n  :host ::ng-deep .p-column-filter-text {\n    border-radius: 4px;\n    height: 100%;\n    line-height: 1.5rem;\n    /*margin: 0.5rem 0;*/\n    padding: 0.5rem;\n    width: 100%;\n  }\n\n  :host ::ng-deep .p-column-filter-text {\n    background: rgb(255, 255, 255) url(/assets/images/input-search-icon.svg) no-repeat 8px;\n  }\n\n  :host ::ng-deep .p-datatable-resizable > .p-datatable-wrapper {\n    overflow-x: visible;\n    min-height: 450px;\n  }\n\n  :host ::ng-deep .p-highlight {\n    border: none;\n    font-weight: bold;\n  }\n\n  :host ::ng-deep .nested-table {\n    border: unset;\n  }\n\n  :host ::ng-deep .p-paginator-page:not(.p-highlight),\n  :host ::ng-deep p-table thead th,\n  :host ::ng-deep .p-datatable-gridlines tbody tr td {\n    border: 1px solid rgb(209, 211, 219);\n  }\n\n  :host ::ng-deep .p-paginator-next,\n  :host ::ng-deep .p-paginator-prev {\n    border: 0;\n  }\n\n  :host ::ng-deep .p-paginator {\n    float: left;\n    margin: 1.5rem 1.5rem 1.5rem 0;\n  }\n\n  :host ::ng-deep span .p-paginator-page:not(.p-highlight) {\n    background-color: unset;\n  }\n\n  :host ::ng-deep .p-paginator-element {\n    background-color: rgb(245, 246, 250);\n    border-radius: .2rem;\n    height: 2rem;\n    margin-right: .5rem;\n    width: 2rem;\n  }\n\n  :host ::ng-deep .p-paginator-icon {\n    color: rgb(000, 000, 000);\n  }\n\n  :host ::ng-deep .p-paginator-first,\n  :host ::ng-deep .p-paginator-last {\n    display: none;\n  }\n\n  :host ::ng-deep .p-paginator-current {\n    order: 2;\n  }\n\n  :host ::ng-deep .ui-dropdown-label {\n    font-size: 0.875rem;\n    padding: 0.5rem 0.5rem 0.5rem 1.4rem\n  }\n\n  td span {\n    white-space: normal;\n  }\n\n  .actionColumn {\n    width: 80px;\n  }\n\n  :host ::ng-deep .calendar-clear-button {\n    background: transparent;\n    border: 0;\n    font-weight: bold;\n    margin: 0.5rem auto 0;\n    text-decoration: underline;\n  }\n\n  .calendar-element-today {\n    border: 1px solid rgb(65, 81, 100);\n  }\n\n  .checkbox-container {\n    margin-bottom: 0.5rem;\n    margin-top: 0.5rem;\n  }\n\n  .checkbox-description {\n    margin-left: 2.5rem;\n  }\n\n  .checkmark {\n    border-radius: 6px;\n    border-width: 2px;\n    /*height: 1.5rem;*/\n    /*width: 1.5rem;*/\n    height: 28px;\n    width: 28px;\n  }\n\n  .chevron-link {\n    display: inline-flex;\n  }\n\n  .display-contents {\n    display: contents;\n  }\n\n  .display-none,\n  :host ::ng-deep .display-none {\n    display: none;\n  }\n\n  .down-arrow:not(.show) {\n    transform: rotate(90deg);\n  }\n\n  .down-arrow, .down-arrow.show {\n    background: url(/assets/images/up-arrow-offgray.svg) no-repeat;\n    height: 7px;\n    float: left;\n    margin-right: 5px;\n    margin-left: 0;\n    width: 11px;\n  }\n\n  .down-arrow.show {\n    transform: rotate(180deg);\n  }\n\n  .missing-data-message {\n    font-weight: bold;\n    margin: 2rem auto;\n    text-align: center;\n  }\n\n  .nested-table td:first-child {\n    padding: 0;\n  }\n\n  tr.table-emptymesage td {\n    height: 30rem;\n    margin-top: 8rem;\n    text-align: center;\n    text-decoration: underline !important;\n    vertical-align: middle;\n  }\n\n  tr.table-emptymesage a {\n    color: rgb(79, 169, 247);\n    font-size: 1rem;\n  }\n\n  tr.table-emptymesage td a:hover {\n    cursor: grabbing;\n  }\n\n  tr.nested-table-body-row td {\n    border: 0 !important;\n  }\n\n  tr.nested-table-header th {\n    background: transparent;\n    border: 0 !important;\n    color: rgb(0, 0, 0);\n    padding-top: 1rem;\n  }\n\n  tr.nested-table-header th:first-child,\n  tr.nested-table-body-row td:first-child {\n    padding-left: 1.7rem;\n  }\n\n  tr.nested-table td div p-table ::ng-deep div div table thead {\n    background-color: unset;\n  }\n\n  .table-responsive {\n    margin-top: 4rem;\n  }\n\n  .u-ta-c {\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
